import { render } from "./MAFormModal.vue?vue&type=template&id=2015a512&scoped=true"
import script from "./MAFormModal.vue?vue&type=script&lang=ts"
export * from "./MAFormModal.vue?vue&type=script&lang=ts"

import "./MAFormModal.vue?vue&type=style&index=0&id=2015a512&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2015a512"

export default script